const TARGET_SELECTOR = '[data-service-addresses]';
const HOME_ADDRESS_FIELDS_SELECTOR =
  '[data-home-address-same-as-service-address-fields]';
const CHECKBOX_SELECTOR = 'input[type="checkbox"]';
import AddressController from './legacy/address_controller';

class MultipleAddresses {
  constructor() {
    this.target = $(TARGET_SELECTOR);
    if (this.target) {
      this.sortAddresses();
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    $("a[data-association='service_address']")
      .data('association-insertion-method', 'append')
      .data('association-insertion-node', '[data-service-addresses]');
    this.target.on('cocoon:after-insert', function(e, insertedItem) {
      new AddressController(insertedItem);
    });
  }

  sortAddresses() {
    this.target
      .find('[data-address-id]')
      .sort(function(a, b) {
        return a.dataset.addressId > b.dataset.addressId;
      })
      .appendTo(this.target);
  }
}

export default MultipleAddresses;



// WEBPACK FOOTER //
// ./src/javascripts/MultipleAddresses.js